import * as React from 'react';
import s from './pageCategoryDisplay.scss';
import {withTranslation} from 'react-i18next';
import MobileNavigation from '../../../containers/MobileNavigation';
import {History} from 'history';
import {Experiment} from '../../../reducers/experiments';
import CurrentLocation from '../CurrentLocation';
import {Article} from '../../../reducers/article';
import {RouteType} from '../../../routes/navigation';

export interface PageCategoryDisplayProps {
  t?: (...args: any[]) => any;
  toggleMenu?: (...args: any[]) => any;
  history: History;
  label?: string;
  searchTerms?: string;
  gotResults?: boolean;
  isMenuOpen?: boolean;
  experiments?: Experiment[];
  articles?: Article[];
  routeType?: RouteType;
}

class PageCategoryDisplay extends React.Component<PageCategoryDisplayProps, {}> {
  render() {
    const {searchTerms, history, label, routeType, experiments = [], articles = []} = this.props;

    if (articles.length < 1) {
      return null;
    }

    return (
      <div className={s.wrap} data-hooks="page-category-display">
        <div className={s.selectedCategory}>
          <CurrentLocation className={s.currentLocation} label={label} searchTerms={searchTerms} experiments={experiments} routeType={routeType}/>
        </div>
        <MobileNavigation history={history} />
      </div>
    );
  }
}
export default withTranslation()(PageCategoryDisplay);
